// 视频测速记录
Vue.component(
    "video-speed-record",
    resolve => require(["../../components/videoSpeed/record.vue"], resolve)
);

// 视频测速记录详情
Vue.component(
    "video-speed-detail",
    resolve => require(["../../components/videoSpeed/detail.vue"], resolve)
);

// 视频测速
Vue.component(
    "video-speed",
    resolve => require(["../../components/videoSpeed/index.vue"], resolve)
);

// 视频测速开始
Vue.component(
    "video-speed-start",
    resolve => require(["../../components/videoSpeed/videoSpeedStart.vue"], resolve)
);

// 视频测速测速
Vue.component(
    "video-speed-run",
    resolve => require(["../../components/videoSpeed/videoSpeedRun.vue"], resolve)
);

// 视频测速结束
Vue.component(
    "video-speed-end",
    resolve => require(["../../components/videoSpeed/videoSpeedEnd.vue"], resolve)
);

// 视频测速结束
Vue.component(
    "video-speed-end-old",
    resolve => require(["../../components/videoSpeed/videoSpeedEndOld.vue"], resolve)
);

// 视频测速结束
Vue.component(
    "video-speed-head",
    resolve => require(["../../components/videoSpeed/videoSpeedHead.vue"], resolve)
);

// 视频测速详情单分辨率数据
Vue.component(
    "video-data-box",
    resolve => require(["../../components/videoSpeed/videoDataBox.vue"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/videoSpeed.js